import classNames from "classnames";
import dayjs from "dayjs";
import React from "react";
import { doorsOpenAtLabel } from "pages/register/common";

import confirmedImage from "../../../assets/images/icon_confirm.svg";
import availableImage from "../../../assets/images/icon_event_available.svg";
import fullImage from "../../../assets/images/icon_event_full.svg";
import styles from "./EventDateOptionCard.module.scss";
import ExternalLink from "../../components/atoms/externalLink";

interface Props {
  availableSeats: number;
  boxSize?: "default" | "large";
  endDate: string;
  locationLink: string | null;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  selected: boolean;
  startDate: string;
  status: "free" | "full";
  takenSeats: number;
  isRegisteredVenue: boolean;
  doorsOpenAt: string;
}

class EventDateOptionCard extends React.PureComponent<Props> {
  public render() {
    const {
      endDate,
      locationLink,
      onClick,
      startDate,
      status,
      selected,
      isRegisteredVenue,
      doorsOpenAt,
    } = this.props;

    const cardWrapperClassName = classNames(styles.cardWrapper, {
      [styles.selected]: selected,
      [styles.disabledCard]: isRegisteredVenue || status === "full",
    });

    const vacancyTextClassName = classNames(styles.vacancy, styles[status]);

    const statusSrc = isRegisteredVenue
      ? confirmedImage
      : status === "free"
      ? availableImage
      : fullImage;

    const statusText = isRegisteredVenue
      ? "申込み済み"
      : status === "free"
      ? "空席あり"
      : "満席";

    const startHoursText = dayjs(startDate).format("HH:mm");

    const endHoursText = dayjs(endDate).format("HH:mm");

    const startDateFormatted = dayjs(startDate).format("YYYY/MM/DD(dd)");
    const endDateFormatted = dayjs(endDate).format("YYYY/MM/DD(dd)");

    const linkComponent = (locationLink: string | null) =>
      locationLink && locationLink.length > 0 ? (
        <ExternalLink to={locationLink}>
          <div className={styles.link}>アクセスはこちらへ</div>
        </ExternalLink>
      ) : (
        <div className={styles.online}>オンライン</div>
      );

    return (
      <div className={styles.venueItem}>
        <div className={cardWrapperClassName} onClick={onClick}>
          <div className={styles.dateContainer}>
            {startDateFormatted === endDateFormatted ? (
              <p
                className={
                  selected ? styles.dateWithAccent : styles.boldStartDate
                }
              >
                {startDateFormatted}
              </p>
            ) : (
              <p
                className={
                  selected ? styles.dateWithAccent : styles.boldStartDate
                }
              >
                {startDateFormatted}~{endDateFormatted}
              </p>
            )}
            <p
              className={selected ? styles.hoursWithAccent : styles.eventHours}
            >
              {startHoursText} ~ {endHoursText}
            </p>
            <p
              className={
                selected
                  ? styles.doorsOpenAtWithAccent
                  : styles.eventDoorsOpenAt
              }
            >
              {doorsOpenAtLabel(doorsOpenAt)}
            </p>
          </div>
          <div>
            <img src={statusSrc} />
          </div>
          <div className={vacancyTextClassName}>
            <p>{statusText}</p>
          </div>
          {linkComponent(locationLink)}
        </div>
      </div>
    );
  }
}

export default EventDateOptionCard;
